import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import {getSavedUserDetails, removeSavedUserDetails} from '../utils/localStorageDataHandler';

function addOwnerAccount(store) {
    const userDetails = getSavedUserDetails();
    request.post(`/${config.url_prefix}/api/addOwnerAccount`)
        .send({
            data: userDetails
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (response.statusCode === 204) {
                removeSavedUserDetails();
                store.dispatch(actions.changeAppState('INTRODUCTION'));
            } else {
                store.dispatch(actions.changeAppState('ERROR'));
            }
        });
}

export default addOwnerAccount;
